import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";

export const NO_ACCESS_MESSAGE =
  "No workspace access available. Please ask your admin to give you access.";

// Shown when a signed-in user has no live workspace (all archived, or every
// membership removed). Owners/admins can create one; everyone else is told to
// ask their admin. can_create_workspace comes from the backend
// (User#can_create_workspace?) — the backend enforces it again on create.
const NoWorkspaceScreen = () => {
  const { user, createWorkspace, switchWorkspace, removeToken } = useAuth();
  const [name, setName] = useState("");
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState(null);
  const canCreate = !!user?.can_create_workspace;

  const handleCreate = async (e) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    setCreating(true);
    setError(null);
    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
      const created = await createWorkspace({ name: trimmed, timezone });
      await switchWorkspace(created);
      window.location.assign(`/${created.uuid}/dashboard`);
    } catch (err) {
      setError(err?.response?.data?.error || err?.message || "Failed to create workspace");
      setCreating(false);
    }
  };

  const handleLogout = () => {
    removeToken();
    window.location.assign("/login");
  };

  return (
    <div className="flex h-svh items-center justify-center bg-background p-4">
      <div className="w-full max-w-sm rounded-xl border border-border bg-card p-6 shadow-sm">
        {canCreate ? (
          <form onSubmit={handleCreate}>
            <h1 className="text-lg font-semibold text-foreground">Create your first workspace</h1>
            <p className="mb-4 mt-1 text-sm text-muted-foreground">
              You don't have any workspaces yet. Create one to get started.
            </p>
            <label htmlFor="new-ws-name" className="mb-1 block text-sm font-medium text-foreground">
              Workspace name
            </label>
            <input
              id="new-ws-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="mb-3 w-full rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground"
            />
            {error && <div className="mb-3 text-sm text-destructive">{error}</div>}
            <button
              type="submit"
              disabled={creating || !name.trim()}
              className="w-full rounded-md bg-primary px-3 py-2 text-sm font-medium text-primary-foreground disabled:opacity-50"
            >
              Create workspace
            </button>
          </form>
        ) : (
          <div>
            <h1 className="text-lg font-semibold text-foreground">No workspace</h1>
            <p className="mb-4 mt-1 text-sm text-muted-foreground">{NO_ACCESS_MESSAGE}</p>
          </div>
        )}
        <button
          type="button"
          onClick={handleLogout}
          className="mt-3 w-full rounded-md border border-border px-3 py-2 text-sm text-foreground"
        >
          Log out
        </button>
      </div>
    </div>
  );
};

export default NoWorkspaceScreen;
